import { HttpInterceptorFn } from '@angular/common/http';

import { createRequestId } from '../utils/request-id.util';

export const requestIdInterceptor: HttpInterceptorFn = (request, next) => {
  return next(
    request.clone({
      setHeaders: {
        'X-Request-ID': createRequestId()
      }
    })
  );
};
